import * as React from "react";
import type { SVGProps } from "react";
const SvgFlightTicket = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.871 6.782A1.2 1.2 0 0 0 16 7l-2.21 1.65a.9.9 0 0 1-.66.15l-5.59-1a.84.84 0 0 0-.47 1.61l3.63 1.54-1.61 1.18a.35.35 0 0 1-.33 0l-1.84-.67a.64.64 0 0 0-.74 1l3.25 4.12a.65.65 0 0 0 1.18-.43l-.18-1.9a.33.33 0 0 1 .13-.3l1.6-1.19.58 3.79a.87.87 0 0 0 1.73 0l.45-5.49a.83.83 0 0 1 .32-.58l2.21-1.64a1.11 1.11 0 0 0 .2-1.61 1.2 1.2 0 0 0-.779-.448"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 21h18a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1 1 1 0 0 1 0-2 1 1 0 0 0 1-1V6a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v4a1 1 0 0 0 1 1 1 1 0 0 1 0 2 1 1 0 0 0-1 1v4a3 3 0 0 0 3 3m-1-3v-3.17a3 3 0 0 0 0-5.66V6a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v3.17a3 3 0 0 0-1.45 4.563A3 3 0 0 0 22 14.83V18a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFlightTicket;
